<template>
  <layout-breadcrumb-cartao
    titulo="Administração"
    :breadcrumb="bread"
    icone="settings"
  >
    <TabelaAdministracao />
  </layout-breadcrumb-cartao>
</template>

<script>
import TabelaAdministracao from "./shared/componentes/TabelaAdministracao";
export default {
  components: {
    TabelaAdministracao
  },
  data() {
    return {
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Administração", url: "/administracao" },
        { titulo: "Administração de Unimeds" }
      ]
    };
  }
};
</script>
